import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { hasRole, isAdminNotConsultant, isConsultantOrHolding, isIndividual, isProfessional, isWholesaler } from "@/js/http/auth.js";
export default {
  name: "App",
  data: function data() {
    return {
      //
    };
  },
  created: function created() {
    this.checkMaintenanceMode();
  },
  methods: {
    checkMaintenanceMode: function checkMaintenanceMode() {
      var isMaintenanceActive = this.$maintenanceMode.isActive;
      var activeMaintenance = this.$maintenanceMode.scheduledMaintenanceAssociated;
      var currentUserGroupValue = null;
      if (isAdminNotConsultant()) currentUserGroupValue = "adminNotConsultant";else if (isConsultantOrHolding()) currentUserGroupValue = "consultantOrHolding";else if (isIndividual()) currentUserGroupValue = "individual";else if (isProfessional()) currentUserGroupValue = "professional";else if (isWholesaler()) currentUserGroupValue = "wholesaler";
      if (isMaintenanceActive && !this.hasDevRole()) {
        var _activeMaintenance$ta;
        var isUserGroupAllowed = false;
        if (activeMaintenance !== null && activeMaintenance !== void 0 && (_activeMaintenance$ta = activeMaintenance.target_groups) !== null && _activeMaintenance$ta !== void 0 && _activeMaintenance$ta.length && currentUserGroupValue) {
          var matchingGroup = activeMaintenance.target_groups.find(function (g) {
            return g.user_group_value === currentUserGroupValue;
          });
          isUserGroupAllowed = (matchingGroup === null || matchingGroup === void 0 ? void 0 : matchingGroup.can_work) == 1 ? true : false;
        }
        if (!isUserGroupAllowed) {
          this.$router.push({
            name: "maintenance"
          });
        }
      } else {
        if (this.$route.name === "maintenance") {
          this.$router.push({
            name: "login"
          });
          location.reload(true);
        }
      }
    },
    hasDevRole: function hasDevRole() {
      return hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    }
  },
  watch: {
    "$maintenanceMode.isActive": function $maintenanceModeIsActive(newValue) {
      this.checkMaintenanceMode();
    }
  }
};